import { FC, useCallback, useEffect } from 'react';
import { KpiAction } from '../../../../services/state/KPI/KPIRequestsStateJ';
import { KPIRequestStatus } from '../../../../data-models/kpi-requests.data-model';
import { useRequestActions, useResetKpiState } from './KPIRequestResponse/hooks/useKPIRequestResponseActions';
import { SentKpiRequestsGrid } from './SentKpiRequestsGrid';
import { SendReminderModal } from './components/SendReminderModal';
import { useKPIRequestsNotSentActions } from './hooks/useKPIRequestsNotSentActions';

const sendStatuses = new Set<KPIRequestStatus>([KPIRequestStatus.Sent, KPIRequestStatus.Archived]);
interface ISendOrResendRequestModalProps {
  status: KPIRequestStatus;
}
export function SendOrResendRequestModal({ status }: ISendOrResendRequestModalProps) {
  const { modalAction, selectedRequest, onCloseModal } = useRequestActions();
  const { sendKPIRequestAction } = useKPIRequestsNotSentActions();

  const onResend = useCallback(async () => {
    if (!selectedRequest) {
      return;
    }
    await sendKPIRequestAction({
      requestsIds: [selectedRequest.id],
      sendReminder: status === KPIRequestStatus.Sent,
    });
  }, [selectedRequest, sendKPIRequestAction, status]);

  return (
    <>
      {(modalAction === KpiAction.sendReminder || modalAction === KpiAction.resend) &&
        selectedRequest &&
        sendStatuses.has(status) && (
          <SendReminderModal
            open
            onClose={onCloseModal}
            request={selectedRequest}
            onConfirm={onResend}
            action={modalAction}
          />
        )}
    </>
  );
}

export const SentRequests: FC<{
  status: typeof KPIRequestStatus.Sent | typeof KPIRequestStatus.Archived;
}> = ({ status }) => {
  const resetRequestState = useResetKpiState();

  useEffect(() => {
    return resetRequestState;
  }, [resetRequestState]);
  return (
    <>
      <SendOrResendRequestModal status={status} />
      <SentKpiRequestsGrid status={status} />
    </>
  );
};
